import styled from 'styled-components'

export const ButtonCategoria = styled.button`
  position: absolute;
  bottom: initial;
  left: 20px;
  top: 21px;
  width: 25px;
  height: 25px;
  align-items: center;
  justify-content: center;
  display: none;
  z-index: 4;
  @media (max-width: 1200px) {
    display: flex;
  }
`

export const StyleSidebar = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 50;
  opacity: ${(props) => (props.visibleCategories ? '1' : '0')};
  pointer-events: ${(props) => (props.visibleCategories ? 'all' : 'none')};
  transition: all 0.3s;
`

export const SidebarMain = styled.div`
  background-color: #ffffff;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transform: ${(props) =>
    props.visibleMainSidebar ? 'translateX(0%)' : 'translateX(-100%)'};
  transition: all 0.4s;
  .cont-menu {
    overflow: auto;
    height: calc(100vh - 98px);
    padding-bottom: 40px;
    background: ${(props) => props.darkTheme && ' #141723'};
    button {
      color: ${(props) => props.darkTheme && '#fff'};
    }
  }
  .btn-pedidos {
    display: flex;
    align-items: center;
    width: 100%;
    height: 48px;
    background-color: #f6f6f8;
    padding: 0px 20px;
    img {
      margin-right: 13px;
    }
    span,
    a {
      font-size: 14px;
      line-height: 17px;
      color: #363843;
    }
  }
  .topo {
    background: ${(props) =>
      props.darkTheme
        ? 'linear-gradient(180deg, #0250b5 -4.51%, #141723 104.58%)'
        : 'linear-gradient(87.38deg, #5C33FF -4.51%, #3399FF 104.58%)'};
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 20px;
    button {
      display: flex;
      align-items: center;
      font-weight: 600;
      font-size: 16px;
      line-height: 22px;
      color: #ffffff;
      img {
        margin-right: 25px;
      }
    }
  }
  ul {
    padding: 0;
    li {
      button {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        line-height: 50px;
        border-bottom: 1px solid #dcdde3;
        font-size: 14px;
        color: #646981;
        padding: 0px 20px;
      }
      .btn-ver-todos {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0px 20px;
        height: 50px;
        letter-spacing: -0.114286px;
        color: #0d71f0;
        font-size: 14px;
      }
    }
  }
`

export const SidebarSub = styled.div`
  background-color: #ffffff;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  transform: ${(props) =>
    props.visibleSubSidebar ? 'translateX(0%)' : 'translateX(-100%)'};
  transition: all 0.4s;
  .cont-menu {
    overflow: auto;
    height: calc(100vh - 98px);
    padding-bottom: 40px;
    background: ${(props) => props.darkTheme && ' #141723'};
    a {
      color: ${(props) => props.darkTheme && '#fff'};
    }
  }
  .btn-pedidos {
    display: flex;
    align-items: center;
    width: 100%;
    height: 48px;
    background-color: #f6f6f8;
    padding: 0px 20px;
    img {
      margin-right: 13px;
    }
    span,
    a {
      font-size: 14px;
      line-height: 17px;
      color: #363843;
    }
  }
  .topo {
    background: ${(props) =>
      props.darkTheme
        ? 'linear-gradient(180deg, #0250b5 -4.51%, #141723 104.58%)'
        : 'linear-gradient(87.38deg, #5C33FF -4.51%, #3399FF 104.58%)'};
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 20px;
    button {
      display: flex;
      align-items: center;
      font-weight: 600;
      font-size: 16px;
      line-height: 22px;
      color: #ffffff;
      img {
        margin-right: 25px;
      }
    }
  }
  ul {
    padding: 0;
    li {
      a {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        line-height: 50px;
        border-bottom: 1px solid #dcdde3;
        font-size: 14px;
        color: #646981;
        padding: 0px 20px;
      }
    }
  }
`
